// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2T6Ur","close":"_1hqG8","modalTitle":"_3YznX","modalImage":"_3oCGX","modalContentText":"_9iMSB"};